import util from '../util'

let controller = 'EnvioTransf'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']), {
  EnvioTransfReserva: function (dto) {
    return util.Axios.Post(controller + '/EnvioTransfReserva', dto)
  },
  EnvioTransfReservaBancariaPix: function (dto) {
    return util.Axios.Post(controller + '/EnvioTransfReservaBancariaPix', dto)
  },
  EnvioTransfReservaBancaria: function (dto) {
    return util.Axios.Post(controller + '/EnvioTransfReservaBancaria', dto)
  }
})
